// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"7d848c1a","408":"bfea6ddc","608":"fabec21c","617":"7d4d87a9","843":"f9519995"}[chunkId] + ".chunk.js";
};